export const locales = {
	hidePassword: 'Masquer le mot de passe',
	showPassword: 'Afficher le mot de passe'
};
